import { dispatcher, IEvent, ingenuity, SpineBase } from "@quest/base-core";
import { gameConstants } from "../Constants/gameConstants";
import { GameParserModel } from "../Platform/GameParserModel";
import { Container } from "@quest/pixi-bridge";
import { BaseGameViewGame } from "./BaseGameViewGame";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { SlotEventConstants } from "@quest/slot-core";
import { SoundConstantGame } from "../Constants/SoundConstantGame";

export class revealSymbolControllerBG {
  protected view: BaseGameViewGame;
  protected symbolSpineArray: SpineBase[] = [];
  protected updatedReelGrid: number[][] = [];
  protected isChestPresent: boolean = false;

  constructor(view: any) {
    this.view = view;
    this.init();
  }

  protected init(): void {
    this.subscribeEvents();
  }

  protected subscribeEvents(): void {
    this.unsubscribeEvents();
    dispatcher.on(eventDispatchers.SHOW_REVEAL_SYMBOL, this.onShowRevealSymbol, this);
    dispatcher.on(eventDispatchers.KILL_REVEAL_OBJECTS, this.killSymbolObjects, this)

  }

  protected unsubscribeEvents(): void {
    dispatcher.off(eventDispatchers.SHOW_REVEAL_SYMBOL, this.onShowRevealSymbol, this);
    dispatcher.off(eventDispatchers.KILL_REVEAL_OBJECTS, this.killSymbolObjects, this)
  }

  // Sets the flow from the creation of Layer all the way to playing the animations of the symbols on the layer and updating the static grid.

  protected onShowRevealSymbol(evt?: IEvent): void {
    this.killSymbolObjects();
    this.symbolSpineArray = [];
    evt.data === "chest" ? (this.isChestPresent = true) : (this.isChestPresent = false);
    this.updatedReelGrid = (ingenuity.parserModel as GameParserModel).getReelGrid();
    this.createRevealSymbolGrid();
    this.playRevealSymbolAnimation();
    dispatcher.fireEvent(eventDispatchers.UPDATE_STATIC_GRID, this.updatedReelGrid);
  }

  // Returns offset array based on whether it's chest or reveal symbol

  protected getOffsetArray(): number[][] {
    let chestOffsetArray: number[][] = []
    if (this.isChestPresent) {
      for (let i = 0; i < this.updatedReelGrid.length; i++) {
        for (let j = 0; j < this.updatedReelGrid[i].length; j++) {
          if (this.updatedReelGrid[i][j] === 13) {
            const reelId = i;
            const row = j - 5;
            chestOffsetArray.push([reelId, row]);
          } else {
            continue;
          }
        }
      }
      (ingenuity.parserModel as GameParserModel).setBaitSymOffsets(chestOffsetArray);
      return chestOffsetArray;
    } else {
      const revealOffsetArray = (ingenuity.parserModel as GameParserModel).getRevealSymOffsets();
      return revealOffsetArray;
    }
  }

  // Iterates over the offset array and creates an animation layer.

  protected createRevealSymbolGrid(): void {
    const symbolOffsetArray: number[][] = this.getOffsetArray();
    const chestRevealPositions = (ingenuity.parserModel as GameParserModel).getChestRevealPositions();
    const revealSymPositions = (ingenuity.parserModel as GameParserModel).getRevealSymPositions();
    symbolOffsetArray.forEach((offset, index) => {
      this.createAnimationLayer(offset[0], offset[1]);
      const position = revealSymPositions[index];
      if (chestRevealPositions.includes(position) && !this.isChestPresent) {
        this.updatedReelGrid[offset[0]][offset[1] + gameConstants.REEL_POSITION_OFFSET] = gameConstants.RESPIN_TRIGGER_SYM
      } else {
        this.updatedReelGrid[offset[0]][offset[1] + gameConstants.REEL_POSITION_OFFSET] = this.getSymNum();
      }
    }, this);
  }

  // Returns Symbol Id of Baits and RevealSym
  protected getSymNum(): number {
    if (this.isChestPresent) {
      const baitTriggered = (ingenuity.parserModel as GameParserModel).getTriggeredBait();
      return (ingenuity.parserModel as GameParserModel).getBaitSymId(baitTriggered);
    } else {
      return (ingenuity.parserModel as GameParserModel).getRevealSymNum();
    }
  }

  // Creates a symbol layer using reelId and Position
  protected createAnimationLayer(reelID: number, pos: number): void {
    const containerID: string = this.isChestPresent
      ? gameConstants.chestReelContainer + reelID
      : gameConstants.revealReelContainer + reelID;
    const symbolContainer: Container = this.view.getContainerByID(containerID);
    symbolContainer.visible = true;
    const symbolID = this.isChestPresent ? gameConstants.CHEST_LAYERED_SYMBOL_ID : gameConstants.REVEAL_LAYERED_SYMBOL_ID;
    const symbolSpine: SpineBase = (this.view as any).createSymbol(symbolID);
    symbolSpine.y = this.getRevealYPosition(pos);
    symbolContainer.addChild(symbolSpine);
    this.symbolSpineArray.push(symbolSpine);
  }


  // Plays Animation of all the symbol layers created.
  //
  protected playRevealSymbolAnimation(): void {
    const winAnim: string = this.isChestPresent ? "chest_win" : "win";
    if (this.symbolSpineArray.length && !this.isChestPresent) {
      (ingenuity.soundManager as any).playSound(SoundConstantGame.REVEAL_ICON_TURNING, 1, false, "soundList");
    }
    for (let i: number = 0; i < this.symbolSpineArray.length; i++) {
      const symbol = this.symbolSpineArray[i];
      symbol.visible = true;
      symbol.playAnim(winAnim);
      symbol.onComplete.addOnce(() => {
        symbol.visible = false;
        if (i === this.symbolSpineArray.length - 1 && this.isChestPresent) {
          dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);

        } else if (i === this.symbolSpineArray.length - 1) {
            ingenuity.configData.isRevealPresent = false;
            dispatcher.fireEvent(eventDispatchers.CHECK_AND_SHOW_NEXT_CASCADE_PRESENTATION);
          }
      });
    }
  }


  // Returns the Y position of the symbol based on position in the Reel. 

  protected getRevealYPosition(position: number): number {
    return  position * 100;
  }

  // To Reset the Array every time the controller is called.

  protected killSymbolObjects(): void {
    this.symbolSpineArray.forEach((symObj: SpineBase) => {
      symObj.destroy();
    });
  }
}
